<script setup lang="ts">
/**
 * 개인정보처리방침(W-FO-15) — design-prototypes/legal-privacy.html 이관.
 * layout-doc(중앙 780px) + LegalContent(본문 SSoT, 약관·개인정보·동의서·모달 공유).
 *
 * 본문은 legal.ts(PRIVACY_DOC)가 SSoT — 원본 claudedocs/legal/04-개인정보처리방침.md 와 양방향 동기화.
 * 법무 확정 전 초안이라 LegalContent 가 상단 초안 고지 배너를 표시한다.
 */
import { useHead } from '@unhead/vue';

import { LegalContent } from '#/components/fo';
import { PageShell } from '#/components/ui';
import { brand } from '#/config/brand';
import { PRIVACY_DOC } from '#/data/legal';

useHead({ title: `${PRIVACY_DOC.title} · ${brand.name}` });
</script>

<template>
  <PageShell variant="legal">
    <LegalContent :doc="PRIVACY_DOC" icon="privacy" />
  </PageShell>
</template>
